<template>
    <div class="certificate-manage">
        <!-- 统计卡片 -->
        <div class="stats-row">
            <div class="stat-card stat-total">
                <div class="stat-icon-wrap">
                    <i class="el-icon-document"></i>
                </div>
                <div class="stat-info">
                    <div class="stat-number">{{ countData.totalCount }}</div>
                    <div class="stat-desc">登记数量</div>
                </div>
            </div>
            <div class="stat-card stat-public">
                <div class="stat-icon-wrap">
                    <i class="el-icon-view"></i>
                </div>
                <div class="stat-info">
                    <div class="stat-number">{{ countData.inPublicCount }}</div>
                    <div class="stat-desc">公示期数量</div>
                </div>
            </div>
        </div>

        <!-- 查询区域 -->
        <el-card class="search-card" shadow="never">
            <el-form :inline="true" :model="queryForm">
                <el-form-item label="企业名称">
                    <el-input v-model="queryForm.companyName" placeholder="请输入企业名称" clearable style="width: 180px;"></el-input>
                </el-form-item>
                <el-form-item label="数据资产名称">
                    <el-input v-model="queryForm.assetName" placeholder="请输入资产名称" clearable style="width: 180px;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 数据表格 -->
        <el-card class="table-card" shadow="never">
            <el-table :data="tableData" border
                :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600' }"
                style="width: 100%;">
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="registrationId" label="资产登记编号" min-width="180" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="companyName" label="企业名称" min-width="200" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="assetName" label="数据资产名称" min-width="200" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="publicityStartTime" label="公示开始日期" width="170" align="center"></el-table-column>
                <el-table-column prop="publicityEndTime" label="公示截止日期" width="170" align="center"></el-table-column>
                <el-table-column prop="creator" label="状态" width="120" align="center"></el-table-column>
                <el-table-column label="是否在官网展示" width="140" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.isPublicity === '1' ? 'success' : 'info'" size="small" effect="light">
                            {{ formatStatus(scope.row.isPublicity) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="140" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" v-if="scope.row.isPublicity === '0'"
                            @click="handlePublicity(scope.row)">开启展示</el-button>
                        <el-button size="mini" type="danger" v-if="scope.row.isPublicity === '1'"
                            @click="handleCancelPublicity(scope.row)">取消展示</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-wrap">
                <el-pagination
                    layout="total, sizes, prev, pager, next"
                    :total="boardsTotal"
                    :page-size="pageSize"
                    :current-page="currPage"
                    :page-sizes="[10, 20, 50]"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
import AddBoardContent from "../../components/AddBoardContent";

export default {
    name: "PropertyManage",
    data() {
        return {
            boardsTotal: 0,
            currPage: 1,
            queryForm: {
                registrationId: '',
                companyName: '',
                assetName: '',
                type: '全部',
                status: '全部'
            },
            countData: {
                totalCount: 0,
                inPublicCount: 0
            },
            tableData: [],
            pageSize: 10,
            currentName: ''
        }
    },
    components: {
        AddBoardContent
    },
    watch: {},
    mounted() {
        this.fetchCountData();
        this.initTableData();
    },
    methods: {
        fetchCountData() {
            this.getRequest('/web/certificate/queryCount').then(resp => {
                if (resp && resp.data) {
                    this.countData = resp.data;
                }
            });
        },
        handleCurrentChange(val) {
            this.currPage = val;
            this.initTableData();
        },
        initTableData() {

            this.getRequest('/web/certificate/queryList?'
                + 'companyName=' + this.queryForm.companyName
                + '&assetName=' + this.queryForm.assetName
                + '&currPage=' + this.currPage + '&pageSize=' + this.pageSize).then(resp => {
                    if (resp && resp.data) {
                        this.boardsTotal = resp.data.total;
                        this.tableData = resp.data.list;
                    }
                });
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.initTableData();
        },
        doSearch() {
            this.currPage = 1;
            this.initTableData();
        },
        resetSearch() {
            this.queryForm = { registrationId: '', companyName: '', assetName: '', type: '全部', status: '全部' };
            this.currPage = 1;
            this.initTableData();
        },
        formatType(type) {
            const types = {
                '1': '初始登记',
                '2': '许可登记',
                '3': '变更登记',
                '4': '转移登记'
            };
            return types[type] || type;
        },
        formatStatus(status) {
            const statusMap = {
                '0': '否',
                '1': '是'
            };
            return statusMap[status] || status;
        },
        handleDetail(row) {
            this.$router.push({
                path: '/index/company/review-manage',
                query: {
                    registrationId: row.registrationId,
                    formData: JSON.stringify(row)
                }
            });
        },
        handlePublicity(row) {
            this.$confirm('确定要公示该数据资产吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.axios.get('/web/certificate/public', {
                    params: {
                        registrationId: row.registrationId
                    }
                }).then(resp => {
                    if (resp && resp.status === 200) {
                        this.$message.success('公示成功');
                        this.fetchCountData();
                        this.initTableData();
                    } else {
                        this.$message.error('公示失败');
                    }
                }).catch(error => {
                    console.error('公示失败:', error);
                    this.$message.error('公示失败: ' + error.message);
                });
            }).catch(() => {
                this.$message.info('已取消操作');
            });
        },
        handleCancelPublicity(row) {
            this.$confirm('确定要取消公示该数据资产吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.axios.get('/web/certificate/cancelPublic', {
                    params: {
                        registrationId: row.registrationId
                    }
                }).then(resp => {
                    if (resp && resp.status === 200) {
                        this.$message.success('取消公示成功');
                        this.fetchCountData();
                        this.initTableData();
                    } else {
                        this.$message.error('取消公示失败');
                    }
                }).catch(error => {
                    console.error('取消公示失败:', error);
                    this.$message.error('取消公示失败: ' + error.message);
                });
            }).catch(() => {
                this.$message.info('已取消操作');
            });
        },
        changeName(name) {
            //console.log(this.currentName)
            this.currentName = name;
            if (name === '') {
                this.initTableData('');
                this.$store.commit('REMOVE_CURRENT_BOARD_ID');
            }
        },
        handleEdit(obj) {
            this.currentName = 'AddBoardContent';
            this.$store.commit('ADD_CURRENT_BOARD_ID', obj.id);
        },
        handleDelete(obj) {
            this.$confirm('是否永久删除名为：【' + obj.assetName + '】的数据资产？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteRequest("/web/board/" + obj.id).then(resp => {
                    this.initTableData('');
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        publishedSwitch(obj) {
            this.getRequest('/web/changeBoard/published?id=' + obj.id + '&published=' + obj.published).then(resp => {
            });
        },
        goToRegistration() {
            this.$router.push('/index/data-registration');
        },
        handleReview(row) {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (!user || !user.id) {
                    throw new Error('无法获取用户信息');
                }

                this.$router.push({
                    path: '/index/company/data-review',
                    query: {
                        id: row.dataAssetsId || row.id,
                        formData: JSON.stringify(row)
                    }
                });
            } catch (error) {
                console.error('跳转审核页面失败:', error);
                this.$message.error('跳转审核页面失败: ' + error.message);
            }
        }
    }
}
</script>



<style scoped>
.certificate-manage {
    padding: 20px 24px;
    background: #f0f2f5;
    min-height: 100%;
}

.stats-row {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
}

.stat-card {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 16px;
    background: #fff;
    border-radius: 10px;
    padding: 20px 24px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    border-left: 4px solid transparent;
    transition: box-shadow 0.2s;
}

.stat-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-total { border-left-color: #409EFF; }
.stat-public { border-left-color: #67C23A; }

.stat-icon-wrap {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    flex-shrink: 0;
}

.stat-total .stat-icon-wrap { background: #ecf5ff; color: #409EFF; }
.stat-public .stat-icon-wrap { background: #f0f9eb; color: #67C23A; }

.stat-number {
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 4px;
}

.stat-total .stat-number { color: #409EFF; }
.stat-public .stat-number { color: #67C23A; }

.stat-desc {
    font-size: 13px;
    color: #909399;
}

.search-card {
    margin-bottom: 16px;
    border-radius: 10px;
    border: none;
}

.search-card >>> .el-card__body {
    padding: 16px 20px 4px;
}

.search-card >>> .el-form-item {
    margin-bottom: 12px;
    margin-right: 16px;
}

.table-card {
    border-radius: 10px;
    border: none;
}

.table-card >>> .el-card__body {
    padding: 16px 20px;
}

.table-card >>> .el-table th {
    font-weight: 600;
}

.table-card >>> .el-table td {
    padding: 10px 0;
}

.pagination-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
}
</style>